
module.config(exportStates);

// @ngInject
function exportStates($stateProvider, TagUrl, moment) {

    var tagUrl = new TagUrl()
        .addTagTypes(['program', 'location', 'participant'])
        .setTagDefault('year', moment().year().toString());


    $stateProvider.state('program.reports.exportStudents', {
        url: tagUrl.buildUrl('/export-students'),
        params: tagUrl.params,
        data: {tagUrl: tagUrl},
        templateUrl: 'reports/export/studentExport',
        controller: 'StudentExportController',
        controllerAs: '$ctrl',
        reloadOnSearch: false,
        resolve: {
            exportTypes: resolveExportTypes,
        }
    });

}

// @ngInject
function resolveExportTypes(program, StudentExportService) {
    return StudentExportService.getAvailableExports(program.id);
}
